export const ADD_TOAST_ID = 'ADD_TOAST_ID';
export const DELETE_TOAST_ID = 'DELETE_TOAST_ID';
export const DELETE_ALL_TOAST_ID = 'DELETE_ALL_TOAST_ID';
/**
 * toast表示制御用のIDを追加する
 * @param toastId
 * @returns {{toastId, type: string}}
 */
export const addToastId = (toastId) => ({
    toastId,
    type: ADD_TOAST_ID,
});
/**
 * toast表示制御用のIDを削除する
 * @param toastId
 * @returns {{toastId, type: string}}
 */
export const deleteToastId = (toastId) => ({
    toastId,
    type: DELETE_TOAST_ID,
});
/**
 * toast表示制御用のIDを全て削除する
 * @returns {{type: string}}
 */
export const deleteAllToastId = () => ({
    type: DELETE_ALL_TOAST_ID,
});
